import type { DrawStroke } from '@/lib/schema.types';

/**
 * Approximate how long a freehand stroke should take to "draw" during playback,
 * derived from its polyline length. Pure + serializable-safe so the offline
 * classroom can replay strokes identically.
 */
export function approximateStrokeDrawDurationMs(stroke: DrawStroke): number {
  const pts = stroke.points;
  if (pts.length < 2) return 400;
  let len = 0;
  for (let i = 1; i < pts.length; i++) {
    len += Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y);
  }
  return Math.min(2400, Math.max(280, len * 4));
}

/** Build the SVG `points` attribute for a stroke polyline. */
export function strokePointsAttr(stroke: DrawStroke): string {
  return stroke.points.map((p) => `${p.x},${p.y}`).join(' ');
}
